import React from 'react';
import {withTranslation} from "react-i18next";

let RewardClaimComponent = ({onClaimClick, t}) => {
	return (
		<div className='claimLink clickable' onClick={onClaimClick}>
			<div className="ghost-btn claim-history-entry claim-history-singleClaim">
				<div className="row"
					 data-tms-event="card-click-impression"
					 data-tms-card-zone="myReward – deal detail"
					 data-tms-card-name="Retrieve my code">
					<div className="col-6 text-center col-retrieveCode no-padding">
						{t('reward.claim.history.retrieveCode')}
					</div>
					<div className="col-3 align-self-center text-center">
						<span className="arrow-right"/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default withTranslation() (RewardClaimComponent)